import styled from "styled-components";

export const Form = styled.form`
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  display: flex;
  flex-direction: column;

  .row {
    --bs-gutter-x: 10px;
  }
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.colors.text.black};
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  margin: 30px 0;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  padding: ${(props) => props.padding || "12px"};
  border: ${(props) =>
    props.border || `1px solid ${props.theme.colors.border.grey}`};
  border-radius: ${(props) => props.borderRadius || "5px"};
  font-size: ${(props) => props.fontSize || "14px"};
  margin-bottom: ${(props) => props.marginBottom || "16px"};
  height: ${(props) => props.height || "inherit"};

  &:focus {
    outline: none;
    border: 1px solid ${(props) => props.theme.colors.primary.main};
  }

  &:placeholder {
    color: ${(props) => props.theme.colors.text.grey};
  }

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

export const Select = styled.select`
  display: block;
  width: 100%;
  padding: ${(props) => props.padding || "12px"};
  border: ${(props) =>
    props.border || `1px solid ${props.theme.colors.border.grey}`};
  border-radius: ${(props) => props.borderRadius || "5px"};
  font-size: ${(props) => props.fontSize || "14px"};
  margin-bottom: ${(props) => props.marginBottom || "16px"};
  height: ${(props) => props.height || "inherit"};
  cursor: pointer;

  &:focus {
    outline: none;
    border: 1px solid ${(props) => props.theme.colors.primary.main};
  }

  /* TODO: 색상 수정 필요 */
  /* &.default {
    color: ${(props) => props.theme.colors.text.grey};
  } */

  /* hide default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* arrow image */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000000' width='18px' height='18px'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 18px 18px;
  padding-right: 30px;
`;

export const InputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: ${(props) => props.margin || "0 0 16px 0"};
  gap: ${(props) => props.gap || "0"};

  > input {
    width: 100%;
    margin: 0;
  }
`;

export const Label = styled.label`
  font-size: ${(props) => props.fontSize || "12px"};
  font-weight: ${(props) => props.fontWeight || "400"};
  color: ${(props) => props.theme.colors.text.black};
  margin-bottom: ${(props) => props.marginBottom || "10px"};
`;

export const LabelRequired = styled(Label)`
  &::after {
    content: "*";
    color: ${(props) => props.theme.colors.primary.main};
  }
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.text.black};
  text-align: ${(props) => props.textAlign || "center"};
  margin-top: ${(props) => props.marginTop || "30px"};
  line-height: 1.5;

  > span {
    margin: 0 5px;
    cursor: pointer;
  }
`;

export const Timer = styled.span`
  position: absolute;
  right: ${(props) => props.right || "120px"};
  font-size: 12px;
  font-weight: 500;
  color: red;
  margin-left: 10px;
`;

export const Line = styled.hr`
  height: 1px;
  background-color: ${(props) => props.theme.colors.border.grey};
  border: none;
  margin: 20px 0;
`;

export const Switch = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

export const SwitchInput = styled.input`
  appearance: none;
  position: relative;
  background-color: ${(props) => props.theme.colors.border.grey};
  border-radius: 1em;
  width: 2.5em;
  height: 1.5em;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    left: 2px;
    width: 1.2em;
    height: 1.2em;
    border-radius: 50%;
    top: 2px;
    transform: scale(0.9);
    background-color: white;
    transition: left 250ms linear;
  }

  &:checked::before {
    background-color: white;
    left: 1.2em;
  }

  &:checked {
    background-color: ${(props) => props.theme.colors.primary.main};
    border-color: ${(props) => props.theme.colors.primary.main};
  }
`;
